// extracted by mini-css-extract-plugin
export default {"container_warp":"Service_container_warp__3jpzz","loadMargin":"Service_loadMargin__t7cpQ","container":"Service_container__rTC3g","text_cover":"Service_text_cover__bWbKu"};